import API from 'services/API';
import moment from 'utils/moment';
import { map, get, orderBy } from 'lodash';

export default function getPdfInfo(params) {
  return API.request({
    method: 'GET',
    url: '/pdf/getPdfInfo',
    params,
    mapper: function (data) {
      const taxClaims = orderBy(
        map(get(data, 'taxClaims'), (taxClaim) => {
          return {
            ...taxClaim,
            createDate: moment.fromServerDatetime(taxClaim.createDate),
          };
        }),
        'number',
        'asc',
      );

      const snu = orderBy(
        map(get(data, 'snus'), (snu) => {
          return {
            ...snu,
            snuDate: moment.fromServerDatetime(snu.snuDate),
          };
        }),
        'snuDate',
        'desc',
      );

      const courtOrders = orderBy(
        map(get(data, 'courtOrders'), (courtOrders) => {
          return {
            ...courtOrders,
            courtOrdersDate: moment.fromServerDatetime(get(courtOrders, 'vspDate')),
          };
        }),
        'courtOrdersDate',
        'desc',
      );
      return {
        ...data,
        snu,
        taxClaims,
        courtOrders,
      };
    },
  });
}
